export async function fetchAppRefreshToken(obj: {
  email: string
  password: string
  locale: string
}) {
  const { email, password, locale } = obj
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client
  const data = {
    password: password,
    client: `${client}_app`,
    language: locale,
    username: email,
    authToken: true,
  }

  return await $fetch(`/customer/login`, {
    method: 'POST',
    body: data,
    baseURL: runtimeConfig.public.apiBaseURL,
    onResponse({ response }) {
      response._data = response._data.data.refreshToken || null
      return response._data
    },
  }).catch(() => {
    return null
  })
}
